module.exports = __webpack_public_path__ + "media/images/emblems/Meienried-coat_of_arms-3d3d1c1ceb46f421cecb860ba2c33e4d.svg";